module.exports = __webpack_public_path__ + "img/event_icon_online_white.c42b232a.png";